import React, { FC } from 'react';
import { isEmpty } from 'lodash';
import { QUESTIONS_TYPES } from 'common/constants/firms';
import { DropdownAndDateAnswers } from 'pages/Funds/components/ProcessManagement/DropdownAndDateAnswers';
import { TextAnswers } from 'pages/Funds/components/ProcessManagement/TextAnswers';
import { ModalAnswerRowProps } from './types';

const ModalAnswerRow: FC<ModalAnswerRowProps> = props => {
  const { task } = props;
  const { question_type: questionType, answers } = task;

  if (!isEmpty(answers)) {
    return (
      <>
        {questionType === QUESTIONS_TYPES.text && <TextAnswers answers={answers} />}
        {questionType === QUESTIONS_TYPES.dropdown && <DropdownAndDateAnswers task={task} isDropdown />}
        {questionType === QUESTIONS_TYPES.date && <DropdownAndDateAnswers task={task} />}
      </>
    );
  }

  return null;
};

export default ModalAnswerRow;
